<template>
    <ContentComp class="p-0">
        <AlertMessage
            v-if="value.Bib === null"
            type="info"
            >{{ $tm('tracking.missingbibforcontestant') }}</AlertMessage
        >

        <FormLayout
            :label-width="120"
            v-else
        >
            <FormLayoutRow>
                <div class="d-md-flex flex-fill align-items-sm-center w-md-50">
                    <FormLayoutLabel
                        tooltip="racecontestantcomplete.gpsdeviceidtooltip"
                        text="racecontestantcomplete.gpsdeviceid"
                    ></FormLayoutLabel>
                    <div class="d-flex w-50">
                        <InputText v-model="value.GPSDeviceID" />
                    </div>
                </div>
                <div class="d-md-flex flex-fill align-items-sm-center w-md-50">
                    <InputBool
                        v-model="value.IgnoreGPSInEQME"
                        label="racecontestantcomplete.ignoreineqme"
                        tooltip="racecontestantcomplete.ignoreineqmetooltip"
                    />

                    <InputBool
                        v-model="value.HideFromTracking"
                        label="racecontestantcomplete.hidefromtracking"
                        tooltip="racecontestantcomplete.hidefromtrackingtooltip"
                    />
                </div>
            </FormLayoutRow>

            <FormLayoutRow v-if="mappoint || devicetracking">
                <div class="d-md-flex flex-fill align-items-sm-center w-md-50 align-self-start mt-3">
                    <TrackingDeviceDetails
                        v-if="devicetracking !== null"
                        :data="devicetracking"
                        :mappoint="mappoint"
                    />
                </div>
                <div class="d-md-flex flex-fill align-items-sm-center w-md-50">
                    <MapComp
                        v-if="devicetracking !== null"
                        class="mt-5 w-100"
                        :tracks="[]"
                        :mapmarkers="[marker]"
                        :centerpoint="mappoint"
                        :showmaplabels="true"
                        :height="400"
                    />
                </div>
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>

<script setup lang="ts">
import { AlertMessage, ContentComp, InputBool, InputText } from '@/components';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import MapComp from '@/components/Map/MapComp.vue';
import { MapMarker } from '@/components/Map/MapMarker';
import { TrackingDeviceDao } from '@/dao';
import { MapPoint, TrackingDevice, type RaceContestantDetails } from '@/objects/generated';
import { watchDebounced } from '@vueuse/core';
import { ref } from 'vue';
import TrackingDeviceDetails from '../Tracking/TrackingDeviceDetails.vue';

const value = defineModel<RaceContestantDetails>({ required: true });

const devicetracking = ref<TrackingDevice | null>(null);
const mappoint = ref<MapPoint | null>(null);
const marker = ref<MapMarker>(new MapMarker());
marker.value.Type = 'pin';

watchDebounced(
    () => value.value.GPSDeviceID,
    async (newVal) => {
        devicetracking.value = null;
        mappoint.value = null;
        if (newVal == null || newVal == '') {
            return;
        }

        let parsed = parseInt(newVal);
        // if the id is not a number between 1000 - 9999 we return
        if (!isNaN(parsed) && parsed >= 1000 && parsed <= 9999) {
            devicetracking.value = await TrackingDeviceDao.GetDevice(parsed);
        } else if (newVal.length >= 6) {
            devicetracking.value = await TrackingDeviceDao.GetDeviceByUniqueID(newVal);
        }

        if (devicetracking.value) {
            mappoint.value = devicetracking.value?.LastKnownPosition ?? null;
            marker.value.Point = mappoint.value;
        }
    },
    {
        immediate: true,
        debounce: 1000,
    },
);
</script>
